"use client";
import * as React from "react";
import { ReactNode } from "react";
import { UseFormReturn } from "react-hook-form";

import {
  RejectMatchExplanationInput,
  RejectMatchOptionsInput,
} from "@/app/(discover)/candidate/invites/components/reject-match-modal/reject-match-form-inputs";
import {
  RejectMatchFormValues,
  rejectMatchOptions,
  RejectMatchOptionValue,
} from "@/app/(discover)/candidate/invites/components/reject-match-modal/reject-match-form-schema";
import ButtonLoader from "@/components/shared/button-loader";
import FormRootError from "@/components/shared/form/form-root-error";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Form } from "@/components/ui/form";

export function RejectMatchModalView({
  formEl,
  onClose,
}: {
  formEl: ReactNode;
  onClose: () => void;
}) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        showCloseButton={true}
        onClick={(e) => e.stopPropagation()}
        className="min-w-0 overflow-x-hidden"
      >
        <DialogHeader className="pb-4 border-b border-border">
          <DialogTitle className="text-sm font-bold text-foreground">
            Help us improve your matches
          </DialogTitle>
          <DialogDescription className="text-xs text-ink-subtle mt-1">
            Your feedback helps us find better schools for you
          </DialogDescription>
        </DialogHeader>

        {formEl}
      </DialogContent>
    </Dialog>
  );
}

export function RejectMatchFormView({
  form,
  onCancel,
  selectedReason,
  onSubmit,
}: {
  form: UseFormReturn<RejectMatchFormValues>;
  selectedReason: RejectMatchOptionValue;
  onSubmit: () => void;
  onCancel: () => void;
}) {
  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="flex flex-col gap-3">
        <RejectMatchOptionsInput form={form} />

        {selectedReason === rejectMatchOptions.OTHER.value && (
          <RejectMatchExplanationInput form={form} />
        )}

        <FormRootError />

        <div className="flex flex-row gap-2 justify-between">
          <Button
            type="button"
            onClick={onCancel}
            variant="outline"
            disabled={form.formState.isSubmitting}
          >
            Cancel
          </Button>
          <ButtonLoader
            type="submit"
            disabled={form.formState.isSubmitting}
            loading={form.formState.isSubmitting}
          >
            Submit
          </ButtonLoader>
        </div>
      </form>
    </Form>
  );
}
